import router from "../router";
import { ImageResourcesUtil } from "./ImageResourcesUtil";
import LoanScopeDataHolder from "../data/model/LoanScopeDataHolder";
import AlertService from "../components/core/alert/AlertService";

export const Activities = {
  //Activities constants
  HOME: "HOME",
  LOGIN: "LOGIN",
  LOAN_DETAILS: "LOAN_DETAILS",
  CLIENT_DETAILS: "CLIENT_DETAILS",
  ASSOCIATED_ENTITY_HOME: "ASSOCIATED_ENTITY_HOME",

  //task activity constants
  CONSENT: "CONSENT",
  SELFIE_WITH_PRODUCT: "SELFIE_WITH_PRODUCT",
  PHOTO_WITH_AGENT: "PHOTO_WITH_AGENT",
  PICTURE: "PICTURE",
  CHOOSE_EMI: "CHOOSE_EMI",
  PROFESSIONAL: "PROFESSIONAL",
  BANK_STATEMENT: "BANK_STATEMENT",
  LOAN_APPROVED_AMOUNT: "LOAN_APPROVED_AMOUNT",
  BANK_DETAILS_VERIFICATION: "BANK_DETAILS_VERIFICATION",
  BANK_DETAILS: "BANK_DETAILS",
  ADDRESS: "ADDRESS",
  PERMANENT_ADDRESS: "PERMANENT_ADDRESS",
  WORK_ADDRESS: "WORK_ADDRESS",
  FAMILY: "FAMILY",
  PROFESSIONAL_ADDITIONAL: "PROFESSIONAL_ADDITIONAL",
  KYC: "KYC",
  KYC_RETAILER: "KYC_RETAILER",
  CHOOSE_EMI_DATE: "CHOOSE_EMI_DATE",
  SIGN_LENDER_DOCUMENT: "SIGN_LENDER_DOCUMENT",
  ENACH: "ENACH",
  CUSTOMER_TASKS_COMPLETED: "CUSTOMER_TASKS_COMPLETED",
  PAN_IMAGE: "PAN_IMAGE",
  LENDER_TERMS_AND_CONDITIONS: "LENDER_TERMS_AND_CONDITIONS",
  NACH_FORM: "NACH_FORM",
  PERFIOS: "PERFIOS",
  CHECK_APPROVAL_STATUS: "CHECK_APPROVAL_STATUS",
  SELECT_CENTER: "SELECT_CENTER",
  NACH: "NACH",
  DOWNPAYMENT: "DOWNPAYMENT",
  INVOICE: "INVOICE",
  STUDENT_DETAILS: "STUDENT_DETAILS",
  WAIT: "WAIT",
  CUSTOMER_PHONE_NUMBER: "CUSTOMER_PHONE_NUMBER",
  LOAN_PRODUCT_DETAILS: "LOAN_PRODUCT_DETAILS",
  WELCOME: "WELCOME",
  OFFICE: "OFFICE",
  KYC_OTP: "KYC_OTP",
  ADDITIONAL_DOCUMENTS: "ADDITIONAL_DOCUMENTS",
  CANCELLED_CHEQUE_COLLECTION: "CANCELLED_CHEQUE_COLLECTION",
  NACH_COLLECTION: "NACH_COLLECTION",
  GST_COPY: "GST_COPY",
  CANCELLED_CHEQUE: "CANCELLED_CHEQUE",
  ALTERNATE_PAN: "ALTERNATE_PAN",
  RESEND_SIGNING_DOCUMENT_LINK: "RESEND_SIGNING_DOCUMENT_LINK",
  COMMUNICATION_ADDRESS: "COMMUNICATION_ADDRESS",
  CHOOSE_BANK_ACCOUNTS: "CHOOSE_BANK_ACCOUNTS",
  BANK_IDENTIFIER: "BANK_IDENTIFIER",
  AADHAAR_IMAGE: "AADHAAR_IMAGE",
  EMI_SCHEME_OPTION: "EMI_SCHEME_OPTION",
  FORM_SIXTY_DETAILS: "FORM_SIXTY_DETAILS",
  FLEET_SUMMARY: "FLEET_SUMMARY",
  SUB_PRODUCT_DETAILS: "SUB_PRODUCT_DETAILS",
  ORGANIZATION_DETAILS: "ORGANIZATION_DETAILS",
  HIRE_VS_BUY_VIABILITY: "HIRE_VS_BUY_VIABILITY",
  FLEET_DETAILS: "FLEET_DETAILS",
  BANK_OTP: "BANK_OTP",
  PAN_ADDED: "PAN_ADDED",
  ASSOCIATED_ENTITY: "ASSOCIATED_ENTITY",
  BUREAU_DETAILS: "BUREAU_DETAILS",

  getActivityDescription: key => ActivitiesDescription[key]
};

export const ActivitiesDescription = {
  //Activities Description
  LOGIN: {
    name: "login"
  },

  LOAN_DETAILS: {
    name: "loan"
  },

  PHOTO_WITH_AGENT: {},

  CLIENT_DETAILS: {
    name: "clientDetails"
  },

  HOME: {
    name: "home"
  },

  ASSOCIATED_ENTITY_HOME: {
    name: "associatedEntity"
  },

  //Task Activities Description
  PAN_ADDED: {
    name: "panCard",
    title: "Pan Card",
    image: ""
  },

  PAN_IMAGE: {
    title: "Pan Image",
    name: "panImage",
    image: ""
  },

  PROFESSIONAL: {
    name: "professional",
    title: "Professional Details",
    image: ImageResourcesUtil.getImageLink(ImageResourcesUtil.PROFESSIONAL)
  },

  BANK_STATEMENT: {
    name: "bankStatement",
    title: "Bank Statements",
    image: ImageResourcesUtil.getImageLink(ImageResourcesUtil.BANK)
  },

  LOAN_APPROVED_AMOUNT: {
    name: "approvedAmount",
    title: "Loan Approved Amount",
    image: ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHEQUE)
  },

  BANK_DETAILS_VERIFICATION: {
    name: "bankDetailsVerification",
    title: "Bank Details Verification",
    image: ImageResourcesUtil.getImageLink(ImageResourcesUtil.BANK)
  },

  BANK_DETAILS: {
    name: "bankDetails",
    title: "Bank Details",
    image: ImageResourcesUtil.getImageLink(ImageResourcesUtil.BANK)
  },

  ADDRESS: {
    name: "address",
    title: "Address",
    image: ""
  },

  PERMANENT_ADDRESS: {
    name: "permanentAddress",
    title: "Permanent Address",
    image: ""
  },

  WORK_ADDRESS: {
    name: "workAddress",
    title: "Company/Business Address",
    image: ""
  },

  COMMUNICATION_ADDRESS: {
    name: "communicationAddress",
    title: "Communication Address",
    image: ""
  },

  CONSENT: {
    title: "Consent",
    image: ""
  },

  SELFIE_WITH_PRODUCT: {
    title: "Customer Photo with Product",
    image: ""
  },

  PICTURE: {
    name: "selfie",
    title: "Customer Photo",
    image: ""
  },

  NACH_FORM: {
    name: "nachForm",
    title: "Upload NACH Form",
    image: ""
  },

  CHOOSE_EMI: {
    name: "emiScheme",
    title: "Choose EMI",
    image: ""
  },

  CHOOSE_EMI_DATE: {
    name: "emiDate",
    title: "Choose EMI Date",
    image: ""
  },

  FAMILY: {
    name: "personal",
    title: "Personal Details",
    image: ""
  },

  PROFESSIONAL_ADDITIONAL: {
    name: "professionalAdditional",
    title: "Professional Details",
    image: ImageResourcesUtil.getImageLink(ImageResourcesUtil.PROFESSIONAL)
  },

  KYC: {
    name: "kyc",
    title: "KYC",
    image: ""
  },

  KYC_RETAILER: {
    name: "kycForRetailer",
    title: "KYC For Retailer",
    image: ""
  },

  SIGN_LENDER_DOCUMENT: {
    name: "signLenderDocument",
    title: "Sign T&C Copy",
    image: ""
  },

  LENDER_TERMS_AND_CONDITIONS: {
    name: "lenderTermsAndConditions"
  },

  ENACH: {
    name: "enach",
    title: "Sign eNACH",
    image: ""
  },

  CUSTOMER_TASKS_COMPLETED: {
    name: "customerTasksCompleted",
    title: "Customer Tasks Completed",
    image: ""
  },

  PERFIOS: {
    name: "perfios",
    title: "Perfios",
    image: ""
  },

  CHECK_APPROVAL_STATUS: {
    name: "approvalStatus",
    title: "Check Approval Status",
    image: ""
  },

  SELECT_CENTER: {
    title: "Coaching Center",
    image: ""
  },

  NACH: {
    name: "nachOptions",
    title: "EMI Payment Registration",
    image: ""
  },

  KYC_OTP: {
    name: "kycOTPVerification",
    title: "KYC OTP Verification",
    image: ""
  },

  ADDITIONAL_DOCUMENTS: {
    name: "additionalDocuments",
    title: "Additional Documents",
    image: ""
  },

  CANCELLED_CHEQUE_COLLECTION: {
    name: "cancelledChequeCollection",
    title: "Cancelled Cheque Collection",
    image: ""
  },

  NACH_COLLECTION: {
    name: "nachCollection",
    title: "NACH Collection",
    image: ""
  },

  GST_COPY: {
    name: "gstCopy",
    title: "GST Copy",
    image: ""
  },

  CANCELLED_CHEQUE: {
    name: "cancelledCheque",
    title: "Cancelled Cheque",
    image: ""
  },

  ALTERNATE_PAN: {
    name: "alternatePAN",
    title: "Proprietor/Corporate PAN",
    image: ""
  },

  RESEND_SIGNING_DOCUMENT_LINK: {
    name: "resendSigningDocumentLink",
    title: "Resend Signing Document Link",
    image: ""
  },

  DOWNPAYMENT: {
    name: "downpayment",
    title: "Downpayment",
    image: ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHEQUE)
  },

  INVOICE: {
    name: "invoice",
    title: "Invoice Copy",
    image: ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHEQUE)
  },

  STUDENT_DETAILS: {
    name: "studentDetails",
    title: "Student Details",
    image: ""
  },

  CHOOSE_BANK_ACCOUNTS: {
    name: "bankAccounts",
    title: "Choose Bank Accounts",
    image: ""
  },

  BANK_IDENTIFIER: {
    name: "bankIdentifierNumber",
    title: "Bank Identifier Number",
    image: ""
  },

  AADHAAR_IMAGE: {
    name: "aadhaarCard",
    title: "Aadhaar Card",
    image: ""
  },

  EMI_SCHEME_OPTION: {
    name: "emiSchemeOption",
    title: "EMI Scheme Option",
    image: ""
  },

  WAIT: {
    name: "wait",
    title: "Wait",
    image: ""
  },

  CUSTOMER_PHONE_NUMBER: {
    name: "customerPhoneNumber"
  },

  LOAN_PRODUCT_DETAILS: {
    name: "loanProductDetails"
  },

  WELCOME: {
    name: "welcome"
  },

  OFFICE: {
    name: "office"
  },

  FORM_SIXTY_DETAILS: {
    name : "form60"
  },

  FLEET_SUMMARY: {
    name : "fleetSummary",
    title: "Fleet Summary",
  },

  SUB_PRODUCT_DETAILS: {
    name : "assetDetails",
    title: "Asset Details",
  },

  ORGANIZATION_DETAILS: {
    name : "organizationDetails",
    title: "Organization Details",
  },

  HIRE_VS_BUY_VIABILITY: {
    name : "hireVsBuyViability",
    title: "Hire vs Buy",
  },

  FLEET_DETAILS: {
    name : "fleetDetails",
    title: "Fleet Details",
  },

  BANK_STATEMENT_VERIFICATION_AND_SALARY: {
    title: "Bank Statement",
  },

  BANK_STATEMENT_VERIFICATION_AND_BALANCE: {
    title: "Bank Statement",
  },

  CUSTOMER_SELFIE_TO_VERIFY_WITH_SELFIE_WITH_PRODUCT: {
    title: "Customer Photo",
  },

  POST_APPROVAL_LOAN_STAGE_COMPLETION: {
    title: "Approval Check",
  },

  BANK_OTP: {
    name: "bankOtp",
    title: "Bank OTP",
    image: ""
  },

  ASSOCIATED_ENTITY: {
    name: "coApplicantsOrGuarantors",
    title: "Add Co-applicant/Guarantor",
    image: ""
  },

  BUREAU_DETAILS: {
    name: "bureauDetails",
    title: "Bureau Details",
    image: ""
  },
};

export default {
  /***
   *
   * @param activity
   *  @returns {boolean} return navigation status
   */
  navigateTo(activity) {
    const activityDescription = ActivitiesDescription[activity];
    if (!activityDescription || !activityDescription.name) {
      AlertService.alert({ message: "Action not found for this task" });
      return false;
    }

    LoanScopeDataHolder.setWaiting(false);
    router.push({ name: activityDescription.name });

    return true;
  }
}

